import { useEffect } from 'react';
import { logAction } from 'utils/logs';
export function useAccessLog(description, equipment = "") {
  useEffect(() => {
    logAction(description, equipment);
  }, []);
}